import { differenceInCalendarDays } from 'date-fns/differenceInCalendarDays';
import { parseISO } from 'date-fns/parseISO';
import { createSelector } from 'reselect';

import { getInboundDate, getOutboundDate } from './search';

export const getNumberOfNights = createSelector(
  [getOutboundDate, getInboundDate],
  (outbound, inbound) =>
    (outbound && inbound && differenceInCalendarDays(parseISO(inbound), parseISO(outbound))) || 0,
);
